import { render, staticRenderFns } from "./WorkPositionPage.vue?vue&type=template&id=96ab29ac&"
import script from "./WorkPositionPage.vue?vue&type=script&lang=js&"
export * from "./WorkPositionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports